import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import styles from "../NavBar/NavbarStyles.module.css";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Badge } from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { sideBarOptions } from "../../Constants";
import HomeIcon from "@mui/icons-material/Home";
import SellIcon from "@mui/icons-material/Sell";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import HistoryIcon from "@mui/icons-material/History";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import IosShareIcon from "@mui/icons-material/IosShare";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import { GROUPS, currentGroup, BASE_URL, CURRENT_ROLE } from "../../API/url";
import { useLocation, useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action/index";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import PsychologyAltIcon from "@mui/icons-material/PsychologyAlt";
import moment from "moment";
import SpeedSharpIcon from "@mui/icons-material/SpeedSharp";
import NotificationsNoneSharpIcon from "@mui/icons-material/NotificationsNoneSharp";
import AlternateEmailSharpIcon from "@mui/icons-material/AlternateEmailSharp";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ManageSearchSharpIcon from "@mui/icons-material/ManageSearchSharp";
import ListAltSharpIcon from "@mui/icons-material/ListAltSharp";
import ChecklistSharpIcon from "@mui/icons-material/ChecklistSharp";
import SentimentSatisfiedAltSharpIcon from "@mui/icons-material/SentimentSatisfiedAltSharp";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import FolderSharedOutlinedIcon from "@mui/icons-material/FolderSharedOutlined";
import CmRootFilter from "../../Component/cmRootFilter/CmRootFilter";
import {
  clearNotifications,
  getUserBadgesSeeker,
  getUserprofilePic,
  userLogout,
} from "../../API/api";
import { useDispatch, useSelector } from "react-redux";
import {
  cmReactToAngular,
  convertEpochToTimestamp,
  filterDomainsForComponent2,
  formatQuestionLength,
  getcurrentRoleValue,
  updateGroups,
  updateRoles,
} from "../../utils";
import Footer from "../Footer/Footer";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LockOpenIcon from "@mui/icons-material/LockOpen";
const drawerWidth = 220;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: `var(--medium_color_shade)`,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer({ children }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [showShare, SetShowShare] = React.useState(false);
  const userState = useSelector((state) => state.user);
  const notificationState = useSelector((state) => state.domain);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentRoute = useLocation();
  const {
    searchInputValue,
    getAllNotifis,
    recommendData,
    profilePagePictureData,
    reloadAnsweredtab,
    isBackClickedOnRecommend,
    trendingDataSelectPageNo,
    reloadTrendingData,
    updatePageNumberHistory,
    getUserBadgesSeekerData,
    getSearchHistorySortFilterVal,
    reloadHistoryPage,
    advanceFilterModalToggle,
    reloadOpenPageData,
    updatePageNoFavourite,
    updatePageNoSharedBy,
    preservePreviousRecommendData,
    updatePageNoAnswered,
    updatePageNoSharedWith,
    keyTermDataPageNoUpdate,
    keyTermWordsReload,
    isTrendingLoadMore,
    updatePageNumberExpertOpenTab,
    refreshExpertOpenTabData,
    cmrUpdatePageNo,
    cmrRefreshPage,
    initialPageNoAMU,
    cmRootUpdateDomainVal
  } = bindActionCreators(Actions, dispatch);
  const openState = useSelector((state) => state.openQuestions);
  const expertRecordsState = useSelector((state)=>state.expertRecord);
  const profilePicState = useSelector((state) => state.profilePage.profilePic);
  const fetchProfilePic = () => {
    if (profilePicState === null) {
      getUserprofilePic()
        .then((res) => {
          if (res===undefined) return;
          if (res.data.data[0].img === null) {
            profilePagePictureData("");
          } else {
            let userPic = `data:image/JPEG;base64,${res.data.data[0].img}`;
            profilePagePictureData(userPic);
          }
        })
        .catch((err) => {});
    }
  };
  const isEmailRole = () => {
    let isEmail = userState.roles.find((x) => x.roleName === "Emails");
    return isEmail === undefined ? false : true;
  };

  const EmailRoleId = () => {
    let isEmail = userState.roles.find((x) => x.roleName === "Emails");
    return isEmail.roleId;
  };

  const onClickShowShare = () => {
    SetShowShare(!showShare);
  };
  React.useEffect(() => {
    fetchProfilePic();
  }, []);

  const onClickClearNotification = () => {
    let newNotifications = notificationState.notifications.filter((notif) => {
      notif.data.status = null;
      return notif;
    });
    getAllNotifis(newNotifications);
    clearNotifications();
  };
  const brandingLogo = () => {
    return `data:image/png;base64,${process.env.REACT_APP_MY_SITE_LOGO}`;
  };
  const sendToHomePage = () => {
    updatePageNumberExpertOpenTab(0);
    refreshExpertOpenTabData(Math.random() * 10);
    navigate(`${Home_PAGE_URL}`);
    searchInputValue("");
  };
  const sendToHistoryPage = () => {
    updatePageNumberHistory(0);
    navigate(`${Home_PAGE_URL}history/`);
    getSearchHistorySortFilterVal({ value: "desc", label: "Asked (Recently)" });
    reloadHistoryPage(Math.random() * 10);
    searchInputValue("");
  };

  const sendToTrendingPage = () => {
    isTrendingLoadMore([0, 0, 0, 0, 0, true]);
    navigate(`${Home_PAGE_URL}trending`);
    isBackClickedOnRecommend(false);
    trendingDataSelectPageNo(0);
    searchInputValue("");
    reloadTrendingData(Math.random() * 10);
  };

  const unreadNotificationCounter = () => {
    let counter = 0;
    if (notificationState.notifications.length > 0) {
      notificationState.notifications.filter((notif) => {
        if (notif.data.status === "null") {
          counter += 1;
        }
      });
    } else {
      counter = 0;
    }
    return counter;
  };

  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("ll");
    }
  };

  const openNotification = (data) => {
    let newNotifications = notificationState.notifications.filter((notif) => {
      if (data.data.msgUuid === notif.data.msgUuid) {
        notif.data.status = null;
      }
      return notif;
    });
    getAllNotifis(newNotifications);
    recommendData(data);
    if (!currentRoute.pathname.includes(`${Home_PAGE_URL}recommend`)) {
      preservePreviousRecommendData([]);
    }
    navigate(`${Home_PAGE_URL}recommend`);
  };

  const sendToAwards = () => {
    // let link = redirectionURL("awards");
    // window.location.href = link;
    getUserBadgesSeeker()
      .then((res) => {
        if (res===undefined) return;
        if (res.data.success || res.data.data !== undefined) {
          getUserBadgesSeekerData(res.data.data);
          advanceFilterModalToggle({ bool: true, value: "seekerAwardsModal" });
        }
      })
      .catch((err) => console.log(err));
  };

  const sendToOpenPage = () => {
    if (CURRENT_ROLE === "Seeker") {
      let randomVal = Math.random() * 10;
      reloadOpenPageData(randomVal.toString());
      navigate(`${Home_PAGE_URL}open`);
    } else {
      updatePageNumberExpertOpenTab(0);
      navigate(`${Home_PAGE_URL}open`);
    }
  };

  const sendToAnsweredPage = () => {
    if (currentRoute.pathname.includes(`${Home_PAGE_URL}answered`)) {
      reloadAnsweredtab();
    }
    searchInputValue("");
    updatePageNoAnswered(0);
    navigate(`${Home_PAGE_URL}answered`);
  };

  const sendToFavouritePage = () => {
    searchInputValue("");
    navigate(`${Home_PAGE_URL}favourite`);
    updatePageNoFavourite(0);
  };

  const sendToSharedByPage = () => {
    searchInputValue("");
    navigate(`${Home_PAGE_URL}sharedby`);
    updatePageNoSharedBy(0);
  };

  const sendToKeyTermPage = () => {
    keyTermWordsReload(0);
    searchInputValue("");
    keyTermDataPageNoUpdate(0);
    navigate(`${Home_PAGE_URL}keyterm`);
  };

  const sendToSharedWithPage = () => {
    searchInputValue("");
    navigate(`${Home_PAGE_URL}sharedwith`);
    updatePageNoSharedWith(0);
  };
  const sendToMyStatPage = () => {
    navigate(`${Home_PAGE_URL}mystat`);
  };
  const sendToProfilePage = () => {
    handleProfilePicClose();
    navigate(`${Home_PAGE_URL}profile`);
  };
  const logoutCurrentUser = () => {
    handleProfilePicClose();
    userLogout();
  };
  const handleChange = (event) => {
    updateGroups(event.target.value);
    // setAuth(event.target.checked);
  };

  const handleProfilePicMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfilePicClose = () => {
    setAnchorEl(null);
  };
  const handleNotificationMenu = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setAnchorEl2(null);
  };
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const showSideBarIcon = (key) => {
    if (key === "home") {
      return <HomeIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "trending1") {
      return <PsychologyAltIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "trending2") {
      return <SellIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "mysearches1") {
      return <QuestionMarkIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "mysearches2") {
      return <QuestionAnswerIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "mysearches3") {
      return <HistoryIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "favourite") {
      return <FavoriteIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "sharedby") {
      return <IosShareIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "sharedwith") {
      return <ShareIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "awards") {
      return <MilitaryTechIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "stat") {
      return <AnalyticsIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmhome") {
      return <SpeedSharpIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmnotification") {
      return <NotificationsNoneSharpIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmemails") {
      return <AlternateEmailSharpIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmexpertrecords") {
      return <ReceiptLongOutlinedIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmsuggestion") {
      return <ManageSearchSharpIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmatomizer") {
      return <ListAltSharpIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmingestedknowledge") {
      return <ChecklistSharpIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmsharedfolder") {
      return <FolderSharedOutlinedIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "cmprofile") {
      return <SentimentSatisfiedAltSharpIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "manageuser") {
      return <PeopleAltOutlinedIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "managerole") {
      return <ManageAccountsIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "managepermision") {
      return <LockOpenIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "restrictPermission") {
      return <BlockOutlinedIcon style={{ fontSize: "20px" }} />;
    }
    if (key === "setting") {
      return <SettingsOutlinedIcon style={{ fontSize: "20px" }} />;
    }
  };
  const redirectionRoutes = (key, route = undefined) => {
    advanceFilterModalToggle({ bool: false, value: "" });
    let newArray = expertRecordsState?.selectedDomainName?.domainId.split(',');
    // console.log(key,route,'check route and key')
    if (key === undefined) {
      if (route.includes("expertRecords/")) {
        if (localStorage.getItem('domainName') !== undefined && newArray!== undefined && newArray.length > 0) {
          let newArray3 = filterDomainsForComponent2(userState.cmTopics)
          let result = newArray3?.filter(item => newArray?.includes(item.indexId))
          cmRootUpdateDomainVal(result)
          cmrUpdatePageNo(1);
        }
        cmrUpdatePageNo(1);
        cmrRefreshPage("hgt");
      }
      if (route.includes("suggestions")) {
        if (localStorage.getItem('domainName') !== undefined && newArray !== undefined && newArray.length > 0) {
          let newArray = expertRecordsState?.selectedDomainName?.domainId.split(',');
          let newArray3 = filterDomainsForComponent2(userState.cmTopics)
          let result = newArray3.filter(item => newArray.includes(item.indexId))
          cmRootUpdateDomainVal(result)
        }
      }
      if (route.includes("cmHome")) {
        if (localStorage.getItem('domainName') !== undefined && newArray !== undefined && newArray.length > 0) {
          let newArray = expertRecordsState?.selectedDomainName?.domainId.split(',');
          let newArray3 = filterDomainsForComponent2(userState.cmTopics)
          let result = newArray3.filter(item => newArray.includes(item.indexId))
          cmRootUpdateDomainVal(result)
        }
      }
      if (route==="/adminhome/") {
        initialPageNoAMU('jk')
      }
      navigate(route);
      return;
    } else {
      cmReactToAngular(key);
    }
  };

  const MuiIconTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "var(--dark_color_shade)",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "var(--dark_color_shade)",
    },
  }));
  const currentPath = useLocation();
  return (
    <>
      <Box
        sx={{
          display: "flex",
          // width: currentPath.pathname.includes("suggestions")
           width: currentPath.pathname.includes("searchHistory")
            ? "95%"
            : currentPath.pathname.includes("expertResponses")
            ? "95%"
            : "auto",
          marginLeft: currentPath.pathname.includes("searchHistory")
            ? "auto"
            : currentPath.pathname.includes("expertResponses")
            ? "auto"
            : null,
          marginRight: currentPath.pathname.includes("searchHistory")
            ? "auto"
            : currentPath.pathname.includes("expertResponses")
            ? "auto"
            : null,
          zIndex: 999,
        }}
      >
        <CssBaseline />
        <AppBar position="fixed" open={open}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 1,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, cursor: "pointer" }}
            >
              <img
                src={brandingLogo()}
                onClick={() => redirectionRoutes("home")}
                style={{ height: "35px" }}
              />
            </Typography>
            {CURRENT_ROLE === "Seeker" && (
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                edge="end"
              >
                <Badge
                  badgeContent={`${
                    userState.fastTrackInfo === undefined
                      ? 0
                      : userState.fastTrackInfo.total -
                        userState.fastTrackInfo.used
                  }/${
                    userState.fastTrackInfo === undefined
                      ? 0
                      : userState.fastTrackInfo.total
                  }`}
                  color="warning"
                >
                  <img
                    src={require("../../Images/fire.png")}
                    alt="fire"
                    style={{ width: "25px", height: "25px" }}
                  />
                </Badge>
              </IconButton>
            )}
            {CURRENT_ROLE === "Expert" && isEmailRole() && (
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                color="inherit"
                edge="end"
              >
                <MailOutlineIcon
                  onClick={() => updateRoles(EmailRoleId(), userState.roles)}
                  color="white"
                  style={{ width: "25px", height: "25px" }}
                />
              </IconButton>
            )}
            {/* <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleNotificationMenu}
              color="inherit"
              edge="end"
            >
              <Badge badgeContent={unreadNotificationCounter()} color="warning">
                <NotificationsNoneIcon
                  color="white"
                  style={{ width: "25px", height: "25px" }}
                />
              </Badge>
            </IconButton> */}
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl2}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl2)}
              onClose={handleNotificationClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  // overflow: 'visible',
                  maxHeight: "300px",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              // style={{height:'300px'}}
            >
              {/* <MenuItem style={{ justifyContent: "end" }}> */}
              {notificationState.notifications.length > 0 && (
                <div className="float-end" style={{ cursor: "pointer" }}>
                  <h6
                    className={styles.markAsRead}
                    onClick={() => onClickClearNotification()}
                  >
                    Mark All As Read
                  </h6>
                </div>
              )}
              {/* </MenuItem> */}
              {notificationState.notifications.length > 0 && (
                <hr style={{ margin: "0px", marginTop: "25px" }} />
              )}
              {notificationState.notifications.length > 0 ? (
                notificationState.notifications.map((notif) => {
                  return (
                    <div
                      className={`${styles.notificationMenuLi} dropdown-item ${
                        notif.data.status === "null" || notif.data.status === 1
                          ? styles.notificationBGColor
                          : null
                      }`}
                      onClick={() => openNotification(notif)}
                    >
                      <h4 className={styles.notificationTypeText}>
                        <i className={notif.icon}></i>
                        &nbsp;{notif.header}
                      </h4>
                      <h5 className={styles.notificationTypeText}>
                        {notif.notification.title}
                        <br />
                        <b>"{formatQuestionLength(notif.data.extraInfo)}"</b>
                      </h5>
                      <h5 className={styles.notificationTimeStamp}>
                        {momentit(notif.data.creationDate)}
                      </h5>
                    </div>
                  );
                })
              ) : (
                <span
                  className={styles.notificationTypeText}
                  style={{ marginInline: "10px" }}
                >
                  No notification available!
                </span>
              )}
            </Menu>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleProfilePicMenu}
              color="inherit"
              edge="end"
            >
              <Avatar
                alt="Remy Sharp"
                src={profilePicState || require("../../Images/cliente.png")}
                style={{ width: "35px", height: "35px" }}
              />
            </IconButton>
            <Menu
              minHeight={100}
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleProfilePicClose}
            >
              {/* <MenuItem
                onClick={() => sendToProfilePage()}
                style={{ fontSize: "13px" }}
              >
                Profile
              </MenuItem> */}
              <MenuItem
                onClick={() => logoutCurrentUser()}
                style={{ fontSize: "13px" }}
              >
                {" "}
                Logout
              </MenuItem>
            </Menu>
            <FormControl sx={{ width: "120px", ml: 2 }}>
              <InputLabel
                id="demo-simple-select-label"
                style={{ color: "#fff" }}
              >
                {userState.firstName} {userState.lastName}
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={getcurrentRoleValue(userState.roles)}
                label={`${userState.firstName} ${userState.lastName}`}
                onChange={(e) => updateRoles(e.target.value, userState.roles)}
                style={{ height: "35px", color: "#fff" }}
              >
                {userState.roles.map((obj) => {
                  return (
                    <MenuItem
                      value={obj.roleId}
                      style={{
                        fontSize: "13px",
                        color: `${
                          getcurrentRoleValue(userState.roles) === obj.roleId &&
                          "#fff"
                        }`,
                        backgroundColor: `${
                          getcurrentRoleValue(userState.roles) === obj.roleId &&
                          "var(--light_color_shade)"
                        }`,
                      }}
                    >
                      {obj.roleName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            {GROUPS.length > 1 && (
              <FormControl sx={{ ml: 1 }}>
                <InputLabel
                  id="demo-simple-select-label"
                  style={{ color: "#fff" }}
                >
                  Group
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={currentGroup}
                  label="Group"
                  onChange={handleChange}
                  style={{ height: "35px", color: "#fff" }}
                >
                  {GROUPS.map((group) => {
                    return (
                      <MenuItem
                        value={group.id}
                        style={{
                          fontSize: "13px",
                          color: `${
                            currentGroup === group.id.toString() && "#fff"
                          }`,
                          backgroundColor: `${
                            currentGroup === group.id.toString() &&
                            "var(--light_color_shade)"
                          }`,
                        }}
                      >
                        {group.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            {sideBarOptions.map((text, index) => (
              <>
                <MuiIconTooltip
                  title={`${!open ? text.label : ""}`}
                  TransitionComponent={Zoom}
                  arrow
                  placement="right"
                >
                  <ListItem
                    key={text.id}
                    disablePadding
                    sx={{ display: "block" }}
                  >
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                        fontSize: "0px",
                      }}
                      onClick={() =>
                        redirectionRoutes(text.redirect, text.route)
                      }
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: "var(--dark_color_shade)",
                        }}
                      >
                        {showSideBarIcon(text.value)}
                      </ListItemIcon>
                      <ListItemText sx={{ opacity: open ? 1 : 0 }}>
                        <span
                          style={{
                            fontSize: "14px",
                            color: "var(--dark_color_shade)",
                          }}
                        >
                          {text.label}
                        </span>
                      </ListItemText>
                    </ListItemButton>
                  </ListItem>
                </MuiIconTooltip>
                {text.ispartition && <Divider />}
              </>
            ))}
          </List>
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: 3,mt:8, width:'95%'}}>
          {(!currentRoute.pathname.includes('searchsuggestionrecords') && !currentRoute.pathname.includes('expertrecordDetail') && !currentRoute.pathname.includes('knowledgeAtomizer') && !currentRoute.pathname.includes('knowledgeIngested')  && !currentRoute.pathname.includes('profile') && ! currentRoute.pathname.includes('sharedfolders') && ! currentRoute.pathname.includes('/adminhome/'))  && <div >
          <CmRootFilter/>
          </div>}
             {/* { currentRoute.pathname.includes('suggestions') && <div >
          <CmRootFilter/>
          </div>} */}
          {children}
        </Box>
      </Box>
      <Footer />
    </>
  );
}
